import { Component, Input, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { IonList, IonItem, IonIcon, IonLabel } from '@ionic/angular/standalone';
import { AuthService } from '../../core/auth.service';
import { environment } from '../../../environments/environment';
import { FabAccountComponent } from '../fab-account/fab-account';

@Component({
    selector: 'menu-account',
    templateUrl: './menu-account.html',
    styleUrls: ['./menu-account.scss'],
    standalone: true,
    imports: [
        CommonModule, 
        RouterModule, 
        FabAccountComponent,
        IonList,
        IonItem,
        IonIcon,
        IonLabel
    ]
})
export class MenuAccountComponent implements OnInit {
  supportURL: string = environment.supportURL;

  @Input() gigs: boolean = false;
  @Input() jobs: boolean = false;
  @Input() vols: boolean = false;
  @Input() ads: boolean = false;
  @Input() payments: boolean = false;
  @Input() support: boolean = false;
  @Input() company: boolean = false;
  @Input() profile: boolean = false;

  constructor(
    public auth: AuthService,
    private router: Router
  ) {}

  ngOnInit() {

  }
  
  logout() {
    this.auth.signOut();
  }

  goDashboard() {
    this.router.navigateByUrl('account/dashboard');
  }

  goNotifications() {
    this.router.navigateByUrl('account/messages');
  }
}
